import { HttpHeaders } from '@angular/common/http';
import {Component, OnInit, TemplateRef} from '@angular/core';
import {DashboardService} from '../dashboard.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ApiService} from '../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {UtilsService} from '../../core/services/utils/utils.service';

@Component({
    selector: 'app-categories',
    templateUrl: './super-categories.component.html',
    styleUrls: ['./super-categories.component.css'],
    standalone: false
})
export class SuperCategoriesComponent implements OnInit {

  headers = new HttpHeaders().set('Content-Type', 'application/json');
  categories = [];
  createdAt: any[] = [];
  modalRef: BsModalRef;
  loading = true;
  loaders = Array(10).fill(0);

  superCat: any = {
    superCatName: '',
    categories: []
  };
  superCategories: any[] = [];

  editMode = false;
  sortType = '';

  constructor(private dashboardService: DashboardService,
              private modalService: BsModalService,
              private api: ApiService,
              private toastr: ToastrService,
              private utils: UtilsService) {
  }

  ngOnInit(): void {
    this.getAllCategories('');
    this.getAllSuperCategories();
  }

  getAllCategories(sorted): void {
    this.dashboardService.getAllCategories(sorted).subscribe((data) => {
      this.categories = data.categories;
    });
  }

  remove(id): void {
    if (confirm('Are you sure you want ot delete this category ?')) {
      this.dashboardService.deleteCategory(id).subscribe((data) => {
        this.toastr.success('Deleted Successfully');
        this.getAllCategories(this.sortType);
      });
    }
  }


  // Super Category
  openModal(template: TemplateRef<any>, isEdit = true): void {
    if (!isEdit) {
      this.superCat = {
        superCatName: '',
        categories: []
      };
    }

    if (this.categories.length){
      this.modalRef = this.modalService.show(template);
    } else {
      this.utils.toastError('Please add categories first!');
    }
  }

  addSuperCat(): void {
    this.api.addSuperCategory(this.superCat).subscribe(res => {
      this.superCat = {superCatName: '', categories: []};
      this.modalRef.hide();
      this.toastr.success('Super Category Added');
      this.getAllSuperCategories();
    }, err => {
      this.toastr.error(err.error.error);
    });
  }

  getAllSuperCategories(): void {
    this.api.getAllSuperCategory().subscribe(res => {
      this.superCategories = res.response;
      this.loading = false;
    }, err => {
      this.loading = false;
    });
  }

  superChildChange(e, id, cName): void {
    if (e.target.checked) {
      this.superCat.categories.push(id);
    } else {
      this.superCat.categories.splice(this.superCat.categories.indexOf(id), 1);
    }
  }

  deleteSuperCategory(id): void {
    if (confirm('Are you sure you want to delete this Super category? (This action can not be undone)')){
      this.api.deleteSuperCategory(id).subscribe(res => {
        this.toastr.success('Super Category deleted successfully!');
        this.getAllSuperCategories();
      }, err => this.toastr.error(err.error.error));
    }
  }

  updateSuperCategory(): void {
    if (confirm('Are you sure you want to update this Super category? (This action can not be undone)')){
      this.api.updateSuperCategory(this.superCat).subscribe(() => {
        this.toastr.success('Super Category updated successfully!');
        this.getAllSuperCategories();
        this.editMode = false;
        this.superCat = {superCatName: '', categories: []};
        this.modalRef.hide();
      }, err => this.toastr.error(err.error.error));
    }
  }

  startEditMode(id, name, categories, superCatModal: TemplateRef<any>): void{
    this.editMode = true;
    this.superCat.superCatName = name;
    this.superCat.categories = [];
    this.superCat['id'] = id;
    categories.forEach(c => this.superCat.categories.push(c.id));
    this.openModal(superCatModal);
  }

  handleCopyToClipboard(str: any = ''): void {
    this.utils.copyToClipboard(str);
    this.utils.toastSuccess('ID copied to your clipboard successfully');
  }
}
